module.exports = __webpack_public_path__ + "RobotoLight.e9e6cf7400ac614f483d.eot";


//////////////////
// WEBPACK FOOTER
// C:/www/onetouchSuperAdmin/src/fonts/RobotoLight.eot
// module id = ../../../../../src/fonts/RobotoLight.eot
// module chunks = 3